import React from 'react';

export const Footer = () => {
  return (
    <>
      <div className="footer-top">
        <div className="container">
          <div className="row">
            <div className="col-md-4">
              <img src={'/images/logo-footer.svg'} alt="Asia part footer logo" />
            </div>
            <div className="col-md-8">
              <div className="footer-frst">
                <h4>Get the spare parts with exclusive offers!</h4>
                <a
                  href=""
                  className="bnr-link"
                  style={{ textDecoration: 'none' }}
                >
                  Contact Us
                </a>
              </div>
            </div>
          </div>
          <hr />
          <div className="row">
            <div className="col-md-4">
              <h5 className="mb-4">
                Subscribe to our
                <br />
                newsletter
              </h5>
              <div className="input-group newsletter">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Email Address"
                  style={{color: "white"}}
                />
                <div className="input-group-append">
                  <button className="btn search-btn" type="button">
                    <i className="fa fa-angle-right" aria-hidden="true"></i>
                  </button>
                </div>
              </div>
              <p className="copy in-desktop">Copyright © 2022 ASIA PART SOUQ</p>
            </div>
            <div className="col-md-8 qlinks">
              <div className="row">
                <div className="col-lg-6">
                  <h6 className="footer-title">Top Brands</h6>
                  <ul className="split-ul">
                    <li>
                      <a href="#" style={{ textDecoration: 'none' }}>
                        Toyota
                      </a>
                    </li>
                    <li>
                      <a href="#" style={{ textDecoration: 'none' }}>
                        Hyundai
                      </a>
                    </li>
                    <li>
                      <a href="#" style={{ textDecoration: 'none' }}>
                        Maruti Suzuki
                      </a>
                    </li>
                    <li>
                      <a href="#" style={{ textDecoration: 'none' }}>
                        Honda
                      </a>
                    </li>
                    <li>
                      <a href="#" style={{ textDecoration: 'none' }}>
                        VW Group
                      </a>
                    </li>
                    <li>
                      <a href="#" style={{ textDecoration: 'none' }}>
                        Nissan
                      </a>
                    </li>
                    <li>
                      <a href="#" style={{ textDecoration: 'none' }}>
                        Renault
                      </a>
                    </li>
                    <li>
                      <a href="#" style={{ textDecoration: 'none' }}>
                        Purolator
                      </a>
                    </li>
                    <li>
                      <a href="#" style={{ textDecoration: 'none' }}>
                        Valeo
                      </a>
                    </li>
                    <li>
                      <a href="#" style={{ textDecoration: 'none' }}>
                        Bosch
                      </a>
                    </li>
                    <li>
                      <a href="#" style={{ textDecoration: 'none' }}>
                        Ngk
                      </a>
                    </li>
                    <li>
                      <a href="#" style={{ textDecoration: 'none' }}>
                        Subros
                      </a>
                    </li>
                    <li>
                      <a href="#" style={{ textDecoration: 'none' }}>
                        Monroe
                      </a>
                    </li>
                    <li>
                      <a href="#" style={{ textDecoration: 'none' }}>
                        Tvs girling
                      </a>
                    </li>
                  </ul>
                </div>
                <div className="col-lg-3">
                  <h6 className="footer-title">Policies</h6>
                  <ul>
                    <li>
                      <a
                        href="#"
                        style={{ textDecoration: 'none' }}
                      >
                        Privacy Policy
                      </a>
                    </li>
                    <li>
                      <a
                        href="#"
                        style={{ textDecoration: 'none' }}
                      >
                        Return Policy
                      </a>
                    </li>
                    <li>
                      <a
                        href="#"
                        style={{ textDecoration: 'none' }}
                      >
                        Shipping Policy
                      </a>
                    </li>
                    <li>
                      <a
                        href="#"
                        style={{ textDecoration: 'none' }}
                      >
                        Terms Of Use
                      </a>
                    </li>
                  </ul>
                </div>
                <div className="col-lg-3">
                  <h6 className="footer-title">Help</h6>
                  <ul>
                    <li>
                      <a href="#"    style={{ textDecoration: 'none' }}>FAQs</a>
                    </li>
                    <li>
                      <a href="#"    style={{ textDecoration: 'none' }}>Contact Us</a>
                    </li>
                  </ul>
                  <ul className="social">
                    <li>
                      <a href="#" style={{ textDecoration: 'none' }}>
                        <i className="fa fa-facebook" aria-hidden="true"></i>
                      </a>
                    </li>
                    <li>
                      <a href="#" style={{ textDecoration: 'none' }}>
                        <i className="fa fa-twitter" aria-hidden="true"></i>
                      </a>
                    </li>
                    <li>
                      <a href="#" style={{ textDecoration: 'none' }}>
                        <i className="fa fa-instagram" aria-hidden="true"></i>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <p className="copy in-mob">Copyright © 2022 ASIA PART SOUQ</p>
        </div>
      </div>
    </>
  );
};
